export default __webpack_public_path__ + "static/media/England.14750015.svg";